
import { defineComponent, PropType, ref, watchEffect } from 'vue';
import GlobalCurrencyIcon from '../icons/GlobalCurrencyIcon.vue';
import { formatNumberDecimals } from '../../../common';
import { config } from '../config';
import { EthersService as eth, convertToUSD } from '../services';
import { exchangeRatesAvailable, exchangeRates } from '../data/global';
import { Mission } from '@/data/missions';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'LiveCard',
  components: {
    GlobalCurrencyIcon
  },
  props: {
    mission: {
      type: Object as PropType<Mission>,
      default: {},
      required: true
    },
    auxIndex: {
      type: Number,
      default: 0,
      required: true
    }
  },
  setup (props: any) {
    const router = useRouter();
    const mission = ref<Mission>();
    const coverIndex = ref<number>(0);
    watchEffect(() => {
      mission.value = props.mission;
      coverIndex.value = mission.value.id ? Number(mission.value.id) % 6 : props.auxIndex;
    });

    const triggerRoute = () => {
      if (mission.value.buttonTarget === '_blank') {
        window.open(mission.value.buttonURL, '_blank');
      } else {
        router.push(mission.value.buttonURL);
      }
    };

    return {
      mission,
      coverIndex,
      sim2dUrl: config.sim2dUrl,
      formatNumberDecimals,
      eth,
      convertToUSD,
      exchangeRatesAvailable,
      exchangeRates,
      triggerRoute
    };
  }
});
